import React, { FC, useRef } from 'react';
import styled from 'styled-components';
import { useWindowWidth } from 'utils/useWindowWidth';

import { TabType } from 'components/common/Tabs/V2Tabs';

import ModificationsContainer, { ModificationsProps } from './ModificationsContainer/ModificationsContainer';
import InfoElements, { InfoElementType } from './InfoElements';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    grid-area: ${(props) => props.isUpperLabel ? '3 / left' : '2 / left'};
`;

interface InfoContainerProps {
    title: string;
    infoElements?: InfoElementType[];
    isUpperLabel?: boolean;
    openOfferTab?: (tab: TabType) => void;
    ratingScore?: number | null;
    scorePrecision?: number | null;
    calculationValues?: string;
    modifications?: ModificationsProps;
}

const InfoContainer: FC<InfoContainerProps> = ({
    infoElements,
    isUpperLabel,
    modifications
}) => {
    const wrapperRef = useRef<HTMLDivElement>();
    const width = useWindowWidth();

    return (

        <Wrapper ref={wrapperRef} isUpperLabel={isUpperLabel} role="list">
            {width > 489 && infoElements && infoElements.length > 0 &&
                <InfoElements infoElements={infoElements}/>}
            {width > 489 && modifications && <ModificationsContainer modifications={modifications}/>}
        </Wrapper>
    );
};

export default InfoContainer;
